import React, { useEffect, useState } from 'react';
import { NJModal, NJModalContent, NJButton } from '@engie-group/fluid-design-system-react';
import { useNavigate } from 'react-router-dom';


const LoginCallbackError = ({ error }) => {
    const [title, setTitle] = useState('Authentication Error');
    const [message, setMessage] = useState('');
    const [message2, setMessage2] = useState('');
    const [showInstructions, setShowInstructions] = useState(false);
    const navigate = useNavigate(); // Initialize the navigate function

    console.error(error);

    useEffect(() => {

        if (error) {
            const { name, errorCode, errorSummary } = error;
            console.error('name', name)
            console.error('errorCode', errorCode)
            console.error('errorSummary', errorSummary)

            setMessage(errorSummary);

            // customized error handling
            if (errorCode === 'access_denied') {
                setTitle('Authentication Notice');
                setMessage(`Add the app to your Okta Catalog.`);
                setMessage2(`To access this service, you need to add 'Job Ad Generator' to your Okta Catalog by following the instructions.`);
                setShowInstructions(true);
            }
        }

    }, [error]);

    const handleOk = () => {
        navigate('/');
    };

    const handleNavigateInstructions = () => {
        const instructionsUrl = process.env.REACT_APP_OKTA_INSTRUCTIONS;
        console.log("Navigating to:", instructionsUrl);

        // Method 1: Replace the current page entirely
        //window.location.href = instructionsUrl;

        // OR Method 2: Open in a new tab/window
        window.open(instructionsUrl, '_blank');
    };


    return (
        <>

            <NJModal
                id="modalFeedback"
                isOpen={true}
            >
                <NJModalContent
                    id="modalOktaError"
                    title={title}
                    onClose={() => handleOk()}
                    footer={
                        <>
                            {
                                !showInstructions &&
                                <NJButton
                                    label="OK"
                                    onClick={handleOk}
                                />
                            }
                            {
                                showInstructions &&
                                <NJButton
                                    label="Show Instructions"
                                    onClick={handleNavigateInstructions}
                                />
                            }
                        </>
                    }
                >
                    <div>
                        {message || 'An error occurred during the authentication process. Please try again.'}
                    </div>
                    <div>
                        {message2}
                    </div>
                </NJModalContent>
            </NJModal>
        </>
    )

};

export default LoginCallbackError; 